import type { FC } from 'react';
import { SerializationDeserializationWrapper } from './SerializationDeserialization.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';
import serialization from './../../../resources/content/serialization.png';

interface SerializationDeserializationProps { }

const SerializationDeserialization: FC<SerializationDeserializationProps> = () => (
   <SerializationDeserializationWrapper>
      <header className="entry-header ">
         <h1 className="entry-title" itemProp="headline">Serialization &amp; Deserialization</h1>
      </header>
      <br/>
      <div className="entry-content clear" itemProp="text" style={{ height: 'auto !important' }}>
         <div className="is-style-default">
            <figure className="aligncenter size-large">
               <img decoding="async" width="578" height="391" src={serialization} alt="" className="lazy-loaded" sizes="(max-width: 578px) 100vw, 578px" />
            </figure>
         </div>
         <br/>
         <h4 className="text-align-justify"><strong>Serialization :</strong></h4>
         <ul className="text-align-justify">
            <li>Serialization is a process where the state of an object is converted into a byte stream.</li>
            <li>The purpose is to travel an object across a network.</li>
            <li>Implement the java.io.Serializable interface, to make a Java object serializable.</li>
            <li>To serialize an object, use the writeObject() method of ObjectOutputStream class.</li>
            <li>If a parent class has implemented a Serializable interface then the child class doesn’t need to implement it, however vice-versa is not true.</li>
            <li>The serialization process only saves non-static data members.</li>
            <li>The serialization process does not save static data members and transient data members.</li>
            <li>While serializing an object, if we don’t want to serialize certain data members of the object, we can mention it transient. To prevent the serialization of a data member, use the transient keyword.</li>
         </ul>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'import java.io.*;\n' +
               'class Student implements Serializable {\n' +
               '  Student(String s) {\n' +
               '    //some code\n' +
               '  }\n' +
               '}\n' +
               'class Test {\n' +
               '  public static void main(String args[]) {\n' +
               '    try {\n' +
               '      Student si = new Student("Ram");\n' +
               '      FileOutputStream fos = new FileOutputStream("Student.ser");\n' +
               '      ObjectOutputStream oos = new ObjectOutputStream(fos);\n' +
               '      oos.writeObject(si);\n' +
               '      oos.close();\n' +
               '      fos.close();\n' +
               '\n' +
               '    } catch (Exception e) {\n' +
               '      e.printStackTrace();\n' +
               '    }\n' +
               '  }\n' +
               '}'
            }
         </SyntaxHighlighter>
         <br/>
         <h4  className="text-align-justify"><strong>Deserialization :</strong></h4>
         <ul  className="text-align-justify">
            <li>Deserialization is the reverse process of serialization. Here we recreate the actual Java object in memory, we use the byte stream. This mechanism is useful for reconstructing the object from the serialized state.</li>
            <li>To deserialize an object, use the readObject() method of ObjectInputStream class.</li>
            <li>When we deserialize an object, the constructor of an object is never called.</li>
            <li>The byte stream created is platform-independent. So, if we serialize the object on one platform, we can deserialize it on a different platform. </li>
         </ul>
         <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
            {
               'import java.io.*;\n' +
               '\n' +
               'class Test {\n' +
               '  public static void main(String args[]) {\n' +
               '    Student si = null;\n' +
               '    try {\n' +
               '      FileInputStream fis = new FileInputStream("Student.ser");\n' +
               '      ObjectInputStream ois = new ObjectInputStream(fis);\n' +
               '      si = (Student) ois.readObject();\n' +
               '\n' +
               '    } catch (Exception e) {\n' +
               '      e.printStackTrace();\n' +
               '    }\n' +
               '  }\n' +
               '}'
            }
         </SyntaxHighlighter>
      </div>
   </SerializationDeserializationWrapper>
);

export default SerializationDeserialization;
